export const FormSelectCountries = [ 
    {
        "value": "afghanistan",
        "label": "Afghanistan",
        "code": "AF"
    },
    {
        "value": "åland islands",
        "label": "Åland Islands",
        "code": "AX"
    },
    {
        "value": "albania",
        "label": "Albania",
        "code": "AL"
    },
    {
        "value": "algeria",
        "label": "Algeria",
        "code": "DZ"
    },
    {
        "value": "american samoa",
        "label": "American Samoa",
        "code": "AS"
    },
    {
        "value": "andora",
        "label": "Andora",
        "code": "AD"
    },
    {
        "value": "angola",
        "label": "Angola",
        "code": "AO"
    },
    {
        "value": "anguilla",
        "label": "Anguilla",
        "code": "AI"
    },
    {
        "value": "antarctica",
        "label": "Antarctica",
        "code": "AQ"
    },
    {
        "value": "antigua and barbuda",
        "label": "Antigua and Barbuda",
        "code": "AG"
    },
    {
        "value": "argentina",
        "label": "Argentina",
        "code": "AR"
    },
    {
        "value": "armenia",
        "label": "Armenia",
        "code": "AM"
    },
    {
        "value": "aruba",
        "label": "Aruba",
        "code": "AW"
    },
    {
        "value": "australia",
        "label": "Australia",
        "code": "AU"
    },
    {
        "value": "austria",
        "label": "Austria",
        "code": "AT"
    },
    {
        "value": "azerbaijan",
        "label": "Azerbaijan",
        "code": "AZ"
    },
    {
        "value": "bahamas",
        "label": "Bahamas",
        "code": "BS"
    },
    {
        "value": "bahrain",
        "label": "Bahrain",
        "code": "BH"
    },
    {
        "value": "bangladesh",
        "label": "Bangladesh",
        "code": "BD"
    },
    {
        "value": "barbados",
        "label": "Barbados",
        "code": "BB"
    },
    {
        "value": "belarus",
        "label": "Belarus",
        "code": "BY"
    },
    {
        "value": "belgium",
        "label": "Belgium",
        "code": "BE"
    },
    {
        "value": "belize",
        "label": "Belize",
        "code": "BZ"
    },
    {
        "value": "benin",
        "label": "Benin",
        "code": "BJ"
    },
    {
        "value": "bermuda",
        "label": "Bermuda",
        "code": "BM"
    },
    {
        "value": "bhutan",
        "label": "Bhutan",
        "code": "BT"
    },
    {
        "value": "bolivia",
        "label": "Bolivia",
        "code": "BO"
    },
    {
        "value": "bosnia and herzegovina",
        "label": "Bosnia and Herzegovina",
        "code": "BA"
    },
    {
        "value": "botswana",
        "label": "Botswana",
        "code": "BW"
    },
    {
        "value": "bouvet island",
        "label": "Bouvet Island",
        "code": "BV"
    },
    {
        "value": "brazil",
        "label": "Brazil",
        "code": "BR"
    },
    {
        "value": "british indian ocean territory",
        "label": "British Indian Ocean Territory",
        "code": "IO"
    },
    {
        "value": "brunei darussalam",
        "label": "Brunei Darussalam",
        "code": "BN"
    },
    {
        "value": "bulgaria",
        "label": "Bulgaria",
        "code": "BG"
    },
    {
        "value": "burkina faso",
        "label": "Burkina Faso",
        "code": "BF"
    },
    {
        "value": "burundi",
        "label": "Burundi",
        "code": "BI"
    },
    {
        "value": "cambodia",
        "label": "Cambodia",
        "code": "KH"
    },
    {
        "value": "cameroon",
        "label": "Cameroon",
        "code": "CM"
    },
    {
        "value": "canada",
        "label": "Canada",
        "code": "CA"
    },
    {
        "value": "cape verde",
        "label": "Cape Verde",
        "code": "CV"
    },
    {
        "value": "cayman islands",
        "label": "Cayman Islands",
        "code": "KY"
    },
    {
        "value": "central african republic",
        "label": "Central African Republic",
        "code": "CF"
    },
    {
        "value": "chad",
        "label": "Chad",
        "code": "TD"
    },
    {
        "value": "chile",
        "label": "Chile",
        "code": "CL"
    },
    {
        "value": "china",
        "label": "China",
        "code": "CN"
    },
    {
        "value": "christmas island",
        "label": "Christmas Island",
        "code": "CX"
    },
    {
        "value": "cocos (keeling) islands",
        "label": "Cocos (Keeling) Islands",
        "code": "CC"
    },
    {
        "value": "colombia",
        "label": "Colombia",
        "code": "CO"
    },
    {
        "value": "comoros",
        "label": "Comoros",
        "code": "KM"
    },
    {
        "value": "congo",
        "label": "Congo",
        "code": "CG"
    },
    {
        "value": "congo, the democratic republic of the",
        "label": "Congo, The Democratic Republic of the",
        "code": "CD"
    },
    {
        "value": "cook islands",
        "label": "Cook Islands",
        "code": "CK"
    },
    {
        "value": "costa rica",
        "label": "Costa Rica",
        "code": "CR"
    },
    {
        "value": "cote d'ivoire",
        "label": "Cote D'Ivoire",
        "code": "CI"
    },
    {
        "value": "croatia",
        "label": "Croatia",
        "code": "HR"
    },
    {
        "value": "cuba",
        "label": "Cuba",
        "code": "CU"
    },
    {
        "value": "cyprus",
        "label": "Cyprus",
        "code": "CY"
    },
    {
        "value": "czech republic",
        "label": "Czech Republic",
        "code": "CZ"
    },
    {
        "value": "denmark",
        "label": "Denmark",
        "code": "DK"
    },
    {
        "value": "djibouti",
        "label": "Djibouti",
        "code": "DJ"
    },
    {
        "value": "dominica",
        "label": "Dominica",
        "code": "DM"
    },
    {
        "value": "dominican republic",
        "label": "Dominican Republic",
        "code": "DO"
    },
    {
        "value": "ecuador",
        "label": "Ecuador",
        "code": "EC"
    },
    {
        "value": "egypt",
        "label": "Egypt",
        "code": "EG"
    },
    {
        "value": "el salvador",
        "label": "El Salvador",
        "code": "SV"
    },
    {
        "value": "equatorial guinea",
        "label": "Equatorial Guinea",
        "code": "GQ"
    },
    {
        "value": "eritrea",
        "label": "Eritrea",
        "code": "ER"
    },
    {
        "value": "estonia",
        "label": "Estonia",
        "code": "EE"
    },
    {
        "value": "ethiopia",
        "label": "Ethiopia",
        "code": "ET"
    },
    {
        "value": "falkland islands (malvinas)",
        "label": "Falkland Islands (Malvinas)",
        "code": "FK"
    },
    {
        "value": "faroe islands",
        "label": "Faroe Islands",
        "code": "FO"
    },
    {
        "value": "fiji",
        "label": "Fiji",
        "code": "FJ"
    },
    {
        "value": "finland",
        "label": "Finland",
        "code": "FI"
    },
    {
        "value": "france",
        "label": "France",
        "code": "FR"
    },
    {
        "value": "french guiana",
        "label": "French Guiana",
        "code": "GF"
    },
    {
        "value": "french polynesia",
        "label": "French Polynesia",
        "code": "PF"
    },
    {
        "value": "french southern territories",
        "label": "French Southern Territories",
        "code": "TF"
    },
    {
        "value": "gabon",
        "label": "Gabon",
        "code": "GA"
    },
    {
        "value": "gambia",
        "label": "Gambia",
        "code": "GM"
    },
    {
        "value": "georgia",
        "label": "Georgia",
        "code": "GE"
    },
    {
        "value": "germany",
        "label": "Germany",
        "code": "DE"
    },
    {
        "value": "ghana",
        "label": "Ghana",
        "code": "GH"
    },
    {
        "value": "gibraltar",
        "label": "Gibraltar",
        "code": "GI"
    },
    {
        "value": "greece",
        "label": "Greece",
        "code": "GR"
    },
    {
        "value": "greenland",
        "label": "Greenland",
        "code": "GL"
    },
    {
        "value": "grenada",
        "label": "Grenada",
        "code": "GD"
    },
    {
        "value": "guadeloupe",
        "label": "Guadeloupe",
        "code": "GP"
    },
    {
        "value": "guam",
        "label": "Guam",
        "code": "GU"
    },
    {
        "value": "guatemala",
        "label": "Guatemala",
        "code": "GT"
    },
    {
        "value": "guernsey",
        "label": "Guernsey",
        "code": "GG"
    },
    {
        "value": "guinea",
        "label": "Guinea",
        "code": "GN"
    },
    {
        "value": "guinea-bissau",
        "label": "Guinea-Bissau",
        "code": "GW"
    },
    {
        "value": "guyana",
        "label": "Guyana",
        "code": "GY"
    },
    {
        "value": "haiti",
        "label": "Haiti",
        "code": "HT"
    },
    {
        "value": "heard island and mcdonald islands",
        "label": "Heard Island and Mcdonald Islands",
        "code": "HM"
    },
    {
        "value": "holy see (vatican city state)",
        "label": "Holy See (Vatican City State)",
        "code": "VA"
    },
    {
        "value": "honduras",
        "label": "Honduras",
        "code": "HN"
    },
    {
        "value": "hong kong",
        "label": "Hong Kong",
        "code": "HK"
    },
    {
        "value": "hungary",
        "label": "Hungary",
        "code": "HU"
    },
    {
        "value": "iceland",
        "label": "Iceland",
        "code": "IS"
    },
    {
        "value": "india",
        "label": "India",
        "code": "IN"
    },
    {
        "value": "indonesia",
        "label": "Indonesia",
        "code": "ID"
    },
    {
        "value": "iran, islamic republic of",
        "label": "Iran, Islamic Republic Of",
        "code": "IR"
    },
    {
        "value": "iraq",
        "label": "Iraq",
        "code": "IQ"
    },
    {
        "value": "ireland",
        "label": "Ireland",
        "code": "IE"
    },
    {
        "value": "isle of man",
        "label": "Isle of Man",
        "code": "IM"
    },
    {
        "value": "israel",
        "label": "Israel",
        "code": "IL"
    },
    {
        "value": "italy",
        "label": "Italy",
        "code": "IT"
    },
    {
        "value": "jamaica",
        "label": "Jamaica",
        "code": "JM"
    },
    {
        "value": "japan",
        "label": "Japan",
        "code": "JP"
    },
    {
        "value": "jersey",
        "label": "Jersey",
        "code": "JE"
    },
    {
        "value": "jordan",
        "label": "Jordan",
        "code": "JO"
    },
    {
        "value": "kazakhstan",
        "label": "Kazakhstan",
        "code": "KZ"
    },
    {
        "value": "kenya",
        "label": "Kenya",
        "code": "KE"
    },
    {
        "value": "kiribati",
        "label": "Kiribati",
        "code": "KI"
    },
    {
        "value": "korea, democratic people's republic of",
        "label": "Korea, Democratic People'S Republic of",
        "code": "KP"
    },
    {
        "value": "korea, republic of",
        "label": "Korea, Republic of",
        "code": "KR"
    },
    {
        "value": "kuwait",
        "label": "Kuwait",
        "code": "KW"
    },
    {
        "value": "kyrgyzstan",
        "label": "Kyrgyzstan",
        "code": "KG"
    },
    {
        "value": "lao people's democratic republic",
        "label": "Lao People'S Democratic Republic",
        "code": "LA"
    },
    {
        "value": "latvia",
        "label": "Latvia",
        "code": "LV"
    },
    {
        "value": "lebanon",
        "label": "Lebanon",
        "code": "LB"
    },
    {
        "value": "lesotho",
        "label": "Lesotho",
        "code": "LS"
    },
    {
        "value": "liberia",
        "label": "Liberia",
        "code": "LR"
    },
    {
        "value": "libyan arab jamahiriya",
        "label": "Libyan Arab Jamahiriya",
        "code": "LY"
    },
    {
        "value": "liechtenstein",
        "label": "Liechtenstein",
        "code": "LI"
    },
    {
        "value": "lithuania",
        "label": "Lithuania",
        "code": "LT"
    },
    {
        "value": "luxembourg",
        "label": "Luxembourg",
        "code": "LU"
    },
    {
        "value": "macao",
        "label": "Macao",
        "code": "MO"
    },
    {
        "value": "macedonia, the former yugoslav republic of",
        "label": "Macedonia, The Former Yugoslav Republic of",
        "code": "MK"
    },
    {
        "value": "madagascar",
        "label": "Madagascar",
        "code": "MG"
    },
    {
        "value": "malawi",
        "label": "Malawi",
        "code": "MW"
    },
    {
        "value": "malaysia",
        "label": "Malaysia",
        "code": "MY"
    },
    {
        "value": "maldives",
        "label": "Maldives",
        "code": "MV"
    },
    {
        "value": "mali",
        "label": "Mali",
        "code": "ML"
    },
    {
        "value": "malta",
        "label": "Malta",
        "code": "MT"
    },
    {
        "value": "marshall islands",
        "label": "Marshall Islands",
        "code": "MH"
    },
    {
        "value": "martinique",
        "label": "Martinique",
        "code": "MQ"
    },
    {
        "value": "mauritania",
        "label": "Mauritania",
        "code": "MR"
    },
    {
        "value": "mauritius",
        "label": "Mauritius",
        "code": "MU"
    },
    {
        "value": "mayotte",
        "label": "Mayotte",
        "code": "YT"
    },
    {
        "value": "mexico",
        "label": "Mexico",
        "code": "MX"
    },
    {
        "value": "micronesia, federated states of",
        "label": "Micronesia, Federated States of",
        "code": "FM"
    },
    {
        "value": "moldova, republic of",
        "label": "Moldova, Republic of",
        "code": "MD"
    },
    {
        "value": "monaco",
        "label": "Monaco",
        "code": "MC"
    },
    {
        "value": "mongolia",
        "label": "Mongolia",
        "code": "MN"
    },
    {
        "value": "montserrat",
        "label": "Montserrat",
        "code": "MS"
    },
    {
        "value": "morocco",
        "label": "Morocco",
        "code": "MA"
    },
    {
        "value": "mozambique",
        "label": "Mozambique",
        "code": "MZ"
    },
    {
        "value": "myanmar",
        "label": "Myanmar",
        "code": "MM"
    },
    {
        "value": "namibia",
        "label": "Namibia",
        "code": "NA"
    },
    {
        "value": "nauru",
        "label": "Nauru",
        "code": "NR"
    },
    {
        "value": "nepal",
        "label": "Nepal",
        "code": "NP"
    },
    {
        "value": "netherlands",
        "label": "Netherlands",
        "code": "NL"
    },
    {
        "value": "netherlands antilles",
        "label": "Netherlands Antilles",
        "code": "AN"
    },
    {
        "value": "new caledonia",
        "label": "New Caledonia",
        "code": "NC"
    },
    {
        "value": "new zealand",
        "label": "New Zealand",
        "code": "NZ"
    },
    {
        "value": "nicaragua",
        "label": "Nicaragua",
        "code": "NI"
    },
    {
        "value": "niger",
        "label": "Niger",
        "code": "NE"
    },
    {
        "value": "nigeria",
        "label": "Nigeria",
        "code": "NG"
    },
    {
        "value": "niue",
        "label": "Niue",
        "code": "NU"
    },
    {
        "value": "norfolk island",
        "label": "Norfolk Island",
        "code": "NF"
    },
    {
        "value": "northern mariana islands",
        "label": "Northern Mariana Islands",
        "code": "MP"
    },
    {
        "value": "norway",
        "label": "Norway",
        "code": "NO"
    },
    {
        "value": "oman",
        "label": "Oman",
        "code": "OM"
    },
    {
        "value": "pakistan",
        "label": "Pakistan",
        "code": "PK"
    },
    {
        "value": "palau",
        "label": "Palau",
        "code": "PW"
    },
    {
        "value": "palestinian territory, occupied",
        "label": "Palestinian Territory, Occupied",
        "code": "PS"
    },
    {
        "value": "panama",
        "label": "Panama",
        "code": "PA"
    },
    {
        "value": "papua new guinea",
        "label": "Papua New Guinea",
        "code": "PG"
    },
    {
        "value": "paraguay",
        "label": "Paraguay",
        "code": "PY"
    },
    {
        "value": "peru",
        "label": "Peru",
        "code": "PE"
    },
    {
        "value": "philippines",
        "label": "Philippines",
        "code": "PH"
    },
    {
        "value": "pitcairn",
        "label": "Pitcairn",
        "code": "PN"
    },
    {
        "value": "poland",
        "label": "Poland",
        "code": "PL"
    },
    {
        "value": "portugal",
        "label": "Portugal",
        "code": "PT"
    },
    {
        "value": "puerto rico",
        "label": "Puerto Rico",
        "code": "PR"
    },
    {
        "value": "qatar",
        "label": "Qatar",
        "code": "QA"
    },
    {
        "value": "reunion",
        "label": "Reunion",
        "code": "RE"
    },
    {
        "value": "romania",
        "label": "Romania",
        "code": "RO"
    },
    {
        "value": "russian federation",
        "label": "Russian Federation",
        "code": "RU"
    },
    {
        "value": "rwanda",
        "label": "RWANDA",
        "code": "RW"
    },
    {
        "value": "saint helena",
        "label": "Saint Helena",
        "code": "SH"
    },
    {
        "value": "saint kitts and nevis",
        "label": "Saint Kitts and Nevis",
        "code": "KN"
    },
    {
        "value": "saint lucia",
        "label": "Saint Lucia",
        "code": "LC"
    },
    {
        "value": "saint pierre and miquelon",
        "label": "Saint Pierre and Miquelon",
        "code": "PM"
    },
    {
        "value": "saint vincent and the grenadines",
        "label": "Saint Vincent and the Grenadines",
        "code": "VC"
    },
    {
        "value": "samoa",
        "label": "Samoa",
        "code": "WS"
    },
    {
        "value": "san marino",
        "label": "San Marino",
        "code": "SM"
    },
    {
        "value": "sao tome and principe",
        "label": "Sao Tome and Principe",
        "code": "ST"
    },
    {
        "value": "saudi arabia",
        "label": "Saudi Arabia",
        "code": "SA"
    },
    {
        "value": "senegal",
        "label": "Senegal",
        "code": "SN"
    },
    {
        "value": "serbia and montenegro",
        "label": "Serbia and Montenegro",
        "code": "CS"
    },
    {
        "value": "seychelles",
        "label": "Seychelles",
        "code": "SC"
    },
    {
        "value": "sierra leone",
        "label": "Sierra Leone",
        "code": "SL"
    },
    {
        "value": "singapore",
        "label": "Singapore",
        "code": "SG"
    },
    {
        "value": "slovakia",
        "label": "Slovakia",
        "code": "SK"
    },
    {
        "value": "slovenia",
        "label": "Slovenia",
        "code": "SI"
    },
    {
        "value": "solomon islands",
        "label": "Solomon Islands",
        "code": "SB"
    },
    {
        "value": "somalia",
        "label": "Somalia",
        "code": "SO"
    },
    {
        "value": "south africa",
        "label": "South Africa",
        "code": "ZA"
    },
    {
        "value": "south georgia and the south sandwich islands",
        "label": "South Georgia and the South Sandwich Islands",
        "code": "GS"
    },
    {
        "value": "spain",
        "label": "Spain",
        "code": "ES"
    },
    {
        "value": "sri lanka",
        "label": "Sri Lanka",
        "code": "LK"
    },
    {
        "value": "sudan",
        "label": "Sudan",
        "code": "SD"
    },
    {
        "value": "suriname",
        "label": "Suriname",
        "code": "SR"
    },
    {
        "value": "svalbard and jan mayen",
        "label": "Svalbard and Jan Mayen",
        "code": "SJ"
    },
    {
        "value": "swaziland",
        "label": "Swaziland",
        "code": "SZ"
    },
    {
        "value": "sweden",
        "label": "Sweden",
        "code": "SE"
    },
    {
        "value": "switzerland",
        "label": "Switzerland",
        "code": "CH"
    },
    {
        "value": "syrian arab republic",
        "label": "Syrian Arab Republic",
        "code": "SY"
    },
    {
        "value": "taiwan, province of china",
        "label": "Taiwan, Province of China",
        "code": "TW"
    },
    {
        "value": "tajikistan",
        "label": "Tajikistan",
        "code": "TJ"
    },
    {
        "value": "tanzania, united republic of",
        "label": "Tanzania, United Republic of",
        "code": "TZ"
    },
    {
        "value": "thailand",
        "label": "Thailand",
        "code": "TH"
    },
    {
        "value": "timor-leste",
        "label": "Timor-Leste",
        "code": "TL"
    },
    {
        "value": "togo",
        "label": "Togo",
        "code": "TG"
    },
    {
        "value": "tokelau",
        "label": "Tokelau",
        "code": "TK"
    },
    {
        "value": "tonga",
        "label": "Tonga",
        "code": "TO"
    },
    {
        "value": "trinidad and tobago",
        "label": "Trinidad and Tobago",
        "code": "TT"
    },
    {
        "value": "tunisia",
        "label": "Tunisia",
        "code": "TN"
    },
    {
        "value": "turkey",
        "label": "Turkey",
        "code": "TR"
    },
    {
        "value": "turkmenistan",
        "label": "Turkmenistan",
        "code": "TM"
    },
    {
        "value": "turks and caicos islands",
        "label": "Turks and Caicos Islands",
        "code": "TC"
    },
    {
        "value": "tuvalu",
        "label": "Tuvalu",
        "code": "TV"
    },
    {
        "value": "uganda",
        "label": "Uganda",
        "code": "UG"
    },
    {
        "value": "ukraine",
        "label": "Ukraine",
        "code": "UA"
    },
    {
        "value": "united arab emirates",
        "label": "United Arab Emirates",
        "code": "AE"
    },
    {
        "value": "united kingdom",
        "label": "United Kingdom",
        "code": "GB"
    },
    {
        "value": "united states",
        "label": "United States",
        "code": "US"
    },
    {
        "value": "united states minor outlying islands",
        "label": "United States Minor Outlying Islands",
        "code": "UM"
    },
    {
        "value": "uruguay",
        "label": "Uruguay",
        "code": "UY"
    },
    {
        "value": "uzbekistan",
        "label": "Uzbekistan",
        "code": "UZ"
    },
    {
        "value": "vanuatu",
        "label": "Vanuatu",
        "code": "VU"
    },
    {
        "value": "venezuela",
        "label": "Venezuela",
        "code": "VE"
    },
    {
        "value": "viet nam",
        "label": "Viet Nam",
        "code": "VN"
    },
    {
        "value": "virgin islands, british",
        "label": "Virgin Islands, British",
        "code": "VG"
    },
    {
        "value": "virgin islands, u.s.",
        "label": "Virgin Islands, U.S.",
        "code": "VI"
    },
    {
        "value": "wallis and futuna",
        "label": "Wallis and Futuna",
        "code": "WF"
    },
    {
        "value": "western sahara",
        "label": "Western Sahara",
        "code": "EH"
    },
    {
        "value": "yemen",
        "label": "Yemen",
        "code": "YE"
    },
    {
        "value": "zambia",
        "label": "Zambia",
        "code": "ZM"
    },
    {
        "value": "zimbabwe",
        "label": "Zimbabwe",
        "code": "ZW"
    }
];